import React from 'react'
import { padDigit, toTimeAgo } from '~/utils'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

type Props = {
  time: Date
  timeNow?: Date
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const TimeAgo = ({ time, timeNow }: Props) => {
  const dateTime = new Date(time)
  const day = dateTime.getDate()
  const month = MONTHS[dateTime.getMonth()]
  const year = dateTime.getFullYear()
  const hours = dateTime.getHours()
  const minutes = dateTime.getMinutes()
  const seconds = dateTime.getSeconds()
  const xm = hours >= 12 ? 'pm' : 'am'

  return (
    <OverlayTrigger
      placement={'top'}
      overlay={
        <Tooltip data-testid={'time-tooltip'}>
          {`${day} ${month} ${year} ${hours == 0 || hours == 12 ? 12 : hours % 12}:${padDigit(minutes)}:${padDigit(
            seconds
          )} ${xm}`}
        </Tooltip>
      }
    >
      <span data-testid={'time-ago'}>{toTimeAgo(time, timeNow)}</span>
    </OverlayTrigger>
  )
}

export const getEventTimeText = (start?: Date, end?: Date, short?: boolean): string => {
  if (!start || !end) return ''
  // typescript complains when defining the localeString options object non-inline even if it is valid.
  // Using ts-ignore to ignore these errors since they make the code a little messier to eliminate
  const optionswDate = short
    ? { hour: 'numeric', minute: '2-digit' }
    : {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      }
  const isSameDay = start.getDay() === end.getDay() && start.getMonth() === end.getMonth()
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const startText = start.toLocaleString([], optionswDate)
  const endText = isSameDay
    ? end.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })
    : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      end.toLocaleString([], { ...optionswDate, timeZoneName: 'short' })
  return `${startText} - ${endText}`
}

export default TimeAgo
